module.exports = __webpack_public_path__ + "static/img/risk_sp2.072047d6.png";